import { useContext, useMemo } from 'react';

import { getSeasonConfig } from './get-season-config';
import { SeasonalThemeContext } from './seasonal-theme-context';

/**
 * Hook to get the appropriate logo based on seasonal theme
 * Returns the seasonal logo when theme is enabled, undefined otherwise
 * Automatically uses the logo from the active season configuration
 *
 * Note: If used outside of SeasonalThemeProvider, returns undefined (graceful degradation)
 */
export const useSeasonalLogo = () => {
	const context = useContext(SeasonalThemeContext);
	const seasonConfig = getSeasonConfig();

	// Gracefully handle usage outside of provider
	const isSeasonalThemeEnabled = context?.isSeasonalThemeEnabled ?? false;

	// Memoize the return value to prevent unnecessary re-renders
	return useMemo(
		() => ({
			logoUrl: isSeasonalThemeEnabled ? seasonConfig.logoLight : undefined,
			isSeasonalTheme: isSeasonalThemeEnabled,
		}),
		[isSeasonalThemeEnabled, seasonConfig.logoLight]
	);
};
